var ko = require('knockout');

function Model(params) {
  var self = this;

  self.stopButtonText = window.language.close || 'Lukk';
  self.videoUrl =
    'https://www.youtube.com/embed/' +
    params.videoId +
    '?showinfo=0&autoplay=0';
  self.thumbnailUrl =
    'https://i.ytimg.com/vi/' + params.videoId + '/maxresdefault.jpg';

  self.videoIsPlaying = ko.observable(false);

  self.playVideo = function() {
    self.videoIsPlaying(true);
  };

  self.stopVideo = function() {
    self.videoIsPlaying(false);
  };

  window.addEventListener('keydown', function(event) {
    if (event.keyCode === 27) {
      self.stopVideo();
    }
  });
}

module.exports = Model;
